import Request from "../lib/request";

export const getPage = (slug) => {
  return Request({
    url: "wp/v2/pages?slug=" + slug,
    method: "get",
  });
};
export const getPages = () => {
  return Request({
    url: "wp/v2/pages",
    method: "get",
  });
};
